<template>
  <span class="v-orb" :style="{ width: size + 'px', height: size + 'px' }" @mouseenter="burst">
    <canvas ref="canvas" :width="size * 3" :height="size * 3" />
  </span>
</template>
<script>
export default {
  name: 'VOrb',
  props: {
    size: { type: Number, default: 36 },
    // milisegundos entre pulsos automáticos
    pulseInterval: { type: Number, default: 5000 }
  },
  data () {
    return {
      raf: null,
      energy: 0,
      lastPulse: 0,
      blobs: [
        { col: [255, 64, 129], a: 0.0, ang: 0.0, dist: 0.30, sp: 0.5, rad: 0.62 },
        { col: [120, 80, 255], a: 1.3, ang: 1.6, dist: 0.34, sp: -0.42, rad: 0.66 },
        { col: [40, 160, 255], a: 2.6, ang: 3.1, dist: 0.28, sp: 0.6, rad: 0.58 },
        { col: [255, 120, 180], a: 4.0, ang: 4.7, dist: 0.22, sp: -0.55, rad: 0.5 }
      ]
    }
  },
  mounted () {
    const ctx = this.$refs.canvas.getContext('2d')
    const W = this.$refs.canvas.width
    const R = W / 2
    let t = 0 // reloj constante para el oleaje (nunca se acelera)
    let phase = 0 // acumulador de rotación: la energía solo cambia su ritmo

    const frame = (now) => {
      const dt = 0.006
      t += dt
      if (now - this.lastPulse > this.pulseInterval) {
        this.burst()
        this.lastPulse = now
      }
      this.energy *= 0.95
      const e = 1 + this.energy * 0.8 // pulso suave: máx ~1.8x el ritmo base
      phase += dt * e

      ctx.clearRect(0, 0, W, W)
      ctx.globalCompositeOperation = 'source-over'
      ctx.fillStyle = '#f4f4f8'
      ctx.fillRect(0, 0, W, W)

      ctx.globalCompositeOperation = 'multiply'
      for (const b of this.blobs) {
        const ang = b.ang + phase * b.sp + Math.sin(t * 0.7 + b.a) * 0.6
        const d = (b.dist + Math.sin(t * 0.9 + b.a) * 0.07) * R
        const x = R + Math.cos(ang) * d
        const y = R + Math.sin(ang) * d
        const rr = b.rad * R * (1 + Math.sin(t + b.a) * 0.08)
        const g = ctx.createRadialGradient(x, y, 0, x, y, rr)
        g.addColorStop(0, `rgba(${b.col[0]},${b.col[1]},${b.col[2]},0.95)`)
        g.addColorStop(1, `rgba(${b.col[0]},${b.col[1]},${b.col[2]},0)`)
        ctx.fillStyle = g
        ctx.beginPath()
        ctx.arc(x, y, rr, 0, Math.PI * 2)
        ctx.fill()
      }

      // viñeta para dar profundidad al borde del círculo
      ctx.globalCompositeOperation = 'source-over'
      const sh = ctx.createRadialGradient(R, R, R * 0.55, R, R, R)
      sh.addColorStop(0, 'rgba(244,244,248,0)')
      sh.addColorStop(1, 'rgba(244,244,248,0.55)')
      ctx.fillStyle = sh
      ctx.beginPath()
      ctx.arc(R, R, R, 0, Math.PI * 2)
      ctx.fill()

      this.raf = requestAnimationFrame(frame)
    }

    this.raf = requestAnimationFrame(frame)
  },
  beforeDestroy () {
    if (this.raf) cancelAnimationFrame(this.raf)
  },
  methods: {
    burst () {
      this.energy = 1
    }
  }
}
</script>
<style scoped>
.v-orb {
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  background: #f4f4f8;
  flex: none;
  vertical-align: middle;
}
.v-orb canvas {
  width: 100%;
  height: 100%;
  display: block;
}
</style>